import { useMemo } from 'react';
import { addUrlParamsToUrl } from '../helpers/updateUrlParams';

export const useIframeUrlParam = (
	url: string,
	relevantSearchParams: URLSearchParams
) => {
	return useMemo(
		() => (!url ? '' : addUrlParamsToUrl(relevantSearchParams, url)),
		[]
	);
};
